/*
 * Страница сущности feast-<кластер>: обзор, материализация/серверы/сервинг и online store из
 * метрик, приложение ArgoCD (argocd/app-selector: viva.io/platform-app=feast), связанные
 * репозитории признаков (dependsOn), поды namespace feast.
 */
import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityDependencyOfComponentsCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import {
  EntityKubernetesContent,
  isKubernetesAvailable,
} from '@backstage/plugin-kubernetes';
import {
  EntityArgoCDOverviewCard,
  isArgocdAvailable,
} from '@roadiehq/backstage-plugin-argo-cd';
import { EntityFeastCards } from './FeastCells';

export const feastEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6} xs={12}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityLinksCard />
        </Grid>
        <EntityFeastCards />
        <Grid item md={12} xs={12}>
          {/* репозитории признаков этого кластера (dependsOn component:feast-<кластер>) */}
          <EntityDependencyOfComponentsCard title="Репозитории признаков" />
        </Grid>
        <EntitySwitch>
          <EntitySwitch.Case if={e => Boolean(isArgocdAvailable(e))}>
            <Grid item md={12} xs={12}>
              <EntityArgoCDOverviewCard />
            </Grid>
          </EntitySwitch.Case>
        </EntitySwitch>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route
      path="/kubernetes"
      title="Kubernetes"
      if={isKubernetesAvailable}
    >
      <EntityKubernetesContent />
    </EntityLayout.Route>
  </EntityLayout>
);
